/**
 * SettingsLanguages template component.
 */
import Animator from '@components/elements/animator/animator';
import Bold from '@components/atoms/text/bold';
import Container from '@components/atoms/container/languagesContainer';
import FlavourConfig from '@shared/config/flavours';
import Focal from '@components/atoms/text/focal';
import LanguageInfoBlock from '@components/atoms/container/languageInfoBlock';
import LanguageContext from '@shared/components/utils/context/languageContext';
import LanguageInfo from '@components/atoms/text/languageInfo';
import LanguagesList from '@components/sections/list/languagesList/languagesList';
import useLanguageSettingsTemplate from '../lib/useLanguageSettingsTemplate';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Displays a list of languages to choose from.
 */
export default function LanguageTemplate() {
  const { displayLanguage, setLanguage, text } = useLanguageSettingsTemplate();
  const menuExpanded = !useAppSelector(selectMenuCollapse);
  return (
    <LanguageContext.Provider value={{ displayLanguage, setLanguage }}>
      <Animator
        id={'languageContainer'}
        type={Animator.Type.SETTING}
        collapse={{ horizontal: menuExpanded }}
      >
        <Container>
          <LanguagesList animate={false} languages={FlavourConfig.languages} />
          <LanguageInfo id={'textLanguageInfo'}>
            <LanguageInfoBlock>
              <Bold id={'titleLanguageInfo'}>{text.title}</Bold>
              <Focal id={'selectionLanguageInfo'}>{text.selection}</Focal>
            </LanguageInfoBlock>
            <LanguageInfoBlock>{text.description}</LanguageInfoBlock>
            <LanguageInfoBlock>{text.action}</LanguageInfoBlock>
          </LanguageInfo>
        </Container>
      </Animator>
    </LanguageContext.Provider>
  );
}
